import { camelCase } from 'lodash';
import React from 'react';

import {
  IMetricConfigMulti,
  IMetricConfigSingle,
} from '../MediaPackDetailEditHighlightsModal.types';
import { IMetricCardProps } from './MetricCard.types';
import { MetricCardMulti } from './MetricCardMulti';
import { MetricCardSingle } from './MetricCardSingle';

export const MetricCard: React.FC<IMetricCardProps> = (props) => {
  return props.metricConfig.isMultiselect ? (
    <MetricCardMulti
      data-testid={`${camelCase(props.metric)}-card`}
      data-active={props.isActive ? '' : undefined}
      {...(props as IMetricCardProps<IMetricConfigMulti>)}
    />
  ) : (
    <MetricCardSingle
      data-testid={`${camelCase(props.metric)}-card`}
      data-active={props.isActive ? '' : undefined}
      {...(props as IMetricCardProps<IMetricConfigSingle>)}
    />
  );
};
